




































































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator'

import HumansStoreModule from '../store/HumansStoreModule'
import AppStoreModule from '@revas/kadra-library/src/core/app/vue/vuex/AppStoreModule'
import CoreStoreModule from '@revas/kadra-library/src/revas/vue/vuex/CoreStoreModule'
import VueI18n from 'vue-i18n'
import VueRouter from 'vue-router'

import { BaseZone, MetaObjectFieldset, InputEvent, ChangeEvent, ClickEvent, PageLayout, ContainerLayout, LinearLayout, BaseHeading, BaseButton, BaseCard, BaseTag, BaseField, BaseFieldset, BaseModal, BaseIcon, BaseAutocompleteSelect, BaseText } from '@revas/reef'

import AppWeeklyDurationsForm from '@/components/workSchedule/AppWeeklyDurationsForm.vue'
import SearchContactActionPayload from '../store/models/contact/SearchContactActionPayload'
import SelectContactActionPayload from '../store/models/contact/SelectContactActionPayload'

import Organization from '@revas/kadra-library/src/revas/vue/vuex/models/Organization'

import AppMessage from '@revas/kadra-library/src/core/app/vue/vuex/AppMessage'
import AppError from '@revas/kadra-library/src/core/app/vue/vuex/AppError'

import cloneDeep from 'lodash.clonedeep'
import isEqual from 'lodash.isequal'
import { WorkSchedule, Contact } from '../models'

@Component({
  components: {
    PageLayout,
    ContainerLayout,
    LinearLayout,
    BaseHeading,
    BaseField,
    BaseFieldset,
    BaseButton,
    BaseCard,
    BaseModal,
    BaseAutocompleteSelect,
    BaseTag,
    BaseIcon,
    MetaObjectFieldset,
    BaseText,
    BaseZone,
    AppWeeklyDurationsForm
  }
})
export default class VWorkScheduleEditor extends Vue {
  @Prop() readonly humansStoreModule!: HumansStoreModule
  @Prop() readonly appStoreModule!: AppStoreModule
  @Prop() readonly coreStoreModule!: CoreStoreModule
  @Prop() readonly i18n!: VueI18n
  @Prop() readonly router!: VueRouter
  @Prop() readonly routeName!: string
  @Prop() readonly resourceId!: string
  @Prop() readonly workScheduleId!: string
  @Prop() readonly organizationId!: string
  @Prop() readonly baseUrl!: string

  private updatedWorkSchedule: WorkSchedule = {
    id: '',
    organizationId: '',
    contactId: '',
    effectiveFrom: '',
    effectiveTo: '',
    hourlyCost: 0,
    hourlyPrice: 0,
    weeklyDurations: [],
    notes: ''
  }

  @Watch('workScheduleId', { immediate: true })
  onWorkScheduleIdChange (workScheduleId: string): void {
    this.humansStoreModule.asyncGetWorkSchedule({
      resourceId: this.resourceId,
      workScheduleId: workScheduleId
    })
  }

  @Watch('workSchedule', { immediate: true })
  onWorkScheduleChange (workSchedule: WorkSchedule) {
    this.updatedWorkSchedule = cloneDeep(workSchedule)
  }

  get workSchedule (): WorkSchedule {
    const t = this.humansStoreModule.currentWorkSchedule
    if (t !== null) {
      return t
    } else {
      return {
        id: '',
        organizationId: '',
        contactId: '',
        effectiveFrom: '',
        effectiveTo: '',
        hourlyCost: 0,
        hourlyPrice: 0,
        weeklyDurations: [],
        notes: ''
      }
    }
  }

  get isPristine () {
    return isEqual(this.workSchedule, this.updatedWorkSchedule)
  }

  get isCreatingWorkSchedule () {
    return this.humansStoreModule.isCreatingWorkSchedule
  }

  private workScheduleValidation = {
    contactId: '',
    effectiveFrom: '',
    effectiveTo: ''
  }

  async saveWorkSchedule () {
    let valid = true
    if (this.selectedContact === null) {
      this.workScheduleValidation.contactId = this.i18n.t('humans.insert_at_least_one_contact').toString()
      valid = false
    } else {
      this.workScheduleValidation.contactId = ''
    }
    if (this.updatedWorkSchedule.effectiveFrom === '' || this.updatedWorkSchedule.effectiveFrom === null) {
      this.workScheduleValidation.effectiveFrom = this.i18n.t('humans.insert_valid_from').toString()
      valid = false
    } else {
      this.workScheduleValidation.effectiveFrom = ''
    }
    if (this.updatedWorkSchedule.effectiveTo === '' || this.updatedWorkSchedule.effectiveTo === null) {
      this.workScheduleValidation.effectiveTo = this.i18n.t('humans.insert_valid_to').toString()
      valid = false
    } else {
      this.workScheduleValidation.effectiveTo = ''
    }
    if (valid) {
      if (this.isPristine) {
        this.goToWorkScheduleCollection()
      } else {
        const oldWorkSchedule = cloneDeep(this.workSchedule)
        await this.humansStoreModule.asyncSaveWorkSchedule({
          workSchedule: this.updatedWorkSchedule
        })
        if (!isEqual(oldWorkSchedule, this.workSchedule)) {
          const message = new AppMessage()
          message.message = this.i18n.t('humans.work_schedule_saved_successfully').toString()
          this.appStoreModule.asyncPushMessage(message)
          this.goToWorkScheduleCollection()
        }
      }
    }
  }

  //
  //
  // Form
  get metaformTemplate () {
    return [
      {
        type: 'sdate',
        key: 'effectiveFrom',
        label: this.i18n.t('humans.valid_from'),
        inputId: 'effectiveFrom',
        message: this.workScheduleValidation.effectiveFrom,
        error: this.workScheduleValidation.effectiveFrom !== ''
      },
      {
        type: 'sdate',
        key: 'effectiveTo',
        label: this.i18n.t('humans.valid_to'),
        inputId: 'effectiveTo',
        message: this.workScheduleValidation.effectiveTo,
        error: this.workScheduleValidation.effectiveTo !== ''
      },
      {
        type: 'currency',
        key: 'hourlyCost',
        label: this.i18n.t('humans.hourly_cost'),
        inputId: 'hourlyCost'
      },
      {
        type: 'currency',
        key: 'hourlyPrice',
        label: this.i18n.t('humans.hourly_price'),
        inputId: 'hourlyPrice'
      },
      {
        type: 'string',
        key: 'notes',
        label: this.i18n.t('humans.notes'),
        inputId: 'notes'
      }
    ]
  }

  onUpdateWorkSchedule ($event: ChangeEvent<WorkSchedule>) {
    if ($event.value === null) {
      const errorPayload = new AppError()
      this.appStoreModule.asyncPushError(errorPayload)
      return
    }
    this.updatedWorkSchedule = $event.value
  }

  onWeeklyDurationChange ($event: number[]) {
    this.updatedWorkSchedule.weeklyDurations = $event
  }

  //
  //
  // Contact Selection

  private contactSearchFilterValue: string | null = ''

  get selectedContact (): Contact | null {
    return this.humansStoreModule.selectedContact
  }

  get contactSearchItems (): Contact[] | null {
    return this.humansStoreModule.contactsSearchedByName
  }

  async onContactSearch ($event: InputEvent<string>) {
    this.contactSearchFilterValue = $event.value
    if (this.contactSearchFilterValue !== null) {
      const payload = new SearchContactActionPayload(this.contactSearchFilterValue, '')
      await this.humansStoreModule.asyncSearchContact(payload)
    }
  }

  onContactSelect ($event: ChangeEvent<Contact>) {
    if ($event.value !== null) {
      this.updatedWorkSchedule.contactId = $event.value.id
      const payload = new SelectContactActionPayload($event.value)
      this.humansStoreModule.selectContact(payload)
    }
  }

  resetSelectedContact ($event: ClickEvent<void>, contact: Contact) {
    if ($event.action === 'delete') {
      this.humansStoreModule.resetSelectedContact()
    } else {
      const intentsUrl = process.env.VUE_APP_REVAS_OS_UI_INTENTS_URL!
      const viewContactUrl = new URL(intentsUrl)
      viewContactUrl.searchParams.append(
        'dataUri',
        `//contacts.revas-api.com/organizations/${this.organizationId}/contacts/${contact.id}`
      )
      viewContactUrl.searchParams.append('action', 'view')

      window.location.href = viewContactUrl.toString()
    }
  }

  //
  //
  // Navigation
  get navbarTitle () {
    if (this.isCreatingWorkSchedule) {
      return this.i18n.t('humans.new_work_schedule')
    } else {
      return this.selectedContact !== null ? this.selectedContact.name : ''
    }
  }

  get organization (): Organization {
    const o = this.coreStoreModule.activeUserOrganization
    if (o !== null) {
      return o
    } else {
      return new Organization()
    }
  }

  goToWorkScheduleCollection () {
    if (this.resourceId === '-') {
      this.router.push({
        name: 'humans.RESOURCE_COLLECTION.$NAME'
      })
    } else {
      this.router.push({
        name: 'humans.RESOURCE_EDITOR.$NAME',
        params: {
          resourceId: this.resourceId
        }
      })
    }
  }

  goToWorkScheduleAvailabilityCalendar () {
    this.router.push({
      name: 'humans.RESOURCE_AVAILABILITY_COLLECTION.$NAME',
      params: {
        workScheduleId: this.workScheduleId
      }
    })
  }

  goToPreviousPage () {
    if (!this.isPristine) {
      this.showCancelModal()
    } else {
      this.goToWorkScheduleCollection()
    }
  }

  private isCancelModalOpen = false

  showCancelModal () {
    if (this.isPristine === true) {
      this.isCancelModalOpen = false
    } else {
      this.isCancelModalOpen = true
    }
  }

  //
  //
  // Delete
  isConfirmationModalVisible = false
  get isWorkScheduleDeleted () {
    return this.humansStoreModule.isWorkScheduleDeleted
  }

  async deleteWorkSchedule () {
    await this.humansStoreModule.asyncDeleteWorkSchedule({
      workScheduleId: this.updatedWorkSchedule.id
    })
    if (this.isWorkScheduleDeleted) {
      const message = new AppMessage()
      message.message = this.i18n.t('humans.work_schedule_deleted_successfully').toString()
      this.appStoreModule.asyncPushMessage(message)
      this.router.push({
        name: 'humans.RESOURCE_COLLECTION.$NAME'
      })
      this.isConfirmationModalVisible = false
    }
  }
}
